import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { PinKeypad } from '@/components/auth/PinKeypad';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';

export default function OkUserAcceso() {
    const { loginUser, role, mustChangePin } = useAuth();
    const nav = useNavigate();
    const [identifier, setIdentifier] = useState('');
    const [pin, setPin] = useState('');
    const [err, setErr] = useState('');
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        if (role === 'user') nav(mustChangePin ? '/change-pin' : '/panel', { replace: true });
    }, [role, mustChangePin, nav]);

    const submit = async (usedPin) => {
        setErr('');
        if (!identifier.trim()) { setErr('Ingresa tu correo o nickname'); return; }
        const p = usedPin || pin;
        if (!p || p.length !== 4) { setErr('Ingresa tu PIN de 4 dígitos'); return; }
        setBusy(true);
        try {
            const data = await loginUser(identifier.trim(), p);
            toast.success(`Bienvenido, @${data.user.nickname}`);
            if (data.must_change_pin) nav('/change-pin', { replace: true });
            else nav('/panel', { replace: true });
        } catch (e) {
            setErr(e?.response?.data?.detail || 'Usuario o PIN incorrecto');
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-screen flex">
            {/* Left hero panel */}
            <div className="hidden lg:flex flex-1 hero-mist items-center justify-center px-10">
                <div className="max-w-md">
                    <img src="/assets/oklovendo-logo.png" alt="Ok te lo vendo" className="h-14 w-auto mb-6" onError={e => { e.target.style.display = 'none'; }} />
                    <h2 className="text-3xl font-semibold tracking-tight">Compra y vende sin fricción.</h2>
                    <p className="mt-2 text-muted-foreground">
                        Ingresa con tu correo electrónico o nickname y PIN de 4 dígitos.<br />
                        Si es tu primer acceso, tu PIN inicial es <span className="font-mono font-semibold">9999</span>.
                    </p>
                </div>
            </div>

            {/* Right form panel */}
            <div className="flex-1 flex items-center justify-center px-4 py-10">
                <div className="w-full max-w-sm">
                    {/* Logo (mobile) */}
                    <div className="flex justify-center mb-5">
                        <img src="/assets/oklovendo-logo.png" alt="Ok te lo vendo" className="h-10 w-auto lg:hidden" onError={e => { e.target.style.display = 'none'; }} />
                    </div>

                    <h1 className="text-2xl font-semibold tracking-tight mb-1 text-center">Iniciar sesión</h1>
                    <p className="text-sm text-muted-foreground mb-6 text-center">Usa tu correo o nickname + PIN de 4 dígitos.</p>

                    <div className="space-y-4">
                        <div>
                            <label className="text-xs text-muted-foreground font-medium">Correo electrónico o Nickname</label>
                            <Input
                                value={identifier}
                                onChange={(e) => setIdentifier(e.target.value)}
                                placeholder="correo@ejemplo.com o tu_nickname"
                                autoComplete="username"
                                autoFocus
                            />
                        </div>

                        <div>
                            <label className="text-xs text-muted-foreground font-medium">PIN (4 dígitos)</label>
                            <PinKeypad onChange={setPin} onComplete={(p) => submit(p)} error={err} />
                            <p className="mt-1 text-[11px] text-muted-foreground">
                                ¿Primer acceso? Usa el PIN inicial <span className="font-mono font-semibold">9999</span>.
                            </p>
                        </div>

                        <Button className="w-full" size="lg" onClick={() => submit()} disabled={busy}>
                            {busy ? 'Ingresando…' : 'Entrar'}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
